// extracted by mini-css-extract-plugin
module.exports = {"varselboks":"Varselboks_varselboks__4AUpA"};